import { render, staticRenderFns } from "./conformity-dashboard.vue?vue&type=template&id=71f38530&"
import script from "./conformity-dashboard.vue?vue&type=script&lang=js&"
export * from "./conformity-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./conformity-dashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports